import {Dispatch} from 'redux';

import Types from '../Types';

import File from '../../../domain/entities/File';
import {Rating, Format} from '../../../domain/entities/Story';

import ImageTextInfo from '../../../domain/value_objects/ImageTextInfo';

export interface Params {
  id?: number | null;
  title?: string | null;
  catchPhrase?: string | null;
  summary?: string | null;
  introduction?: string | null;
  coverIllustrator?: string | null;
  rating?: Rating | null;
  format?: Format | null;
  hasImage?: boolean | null;
  originalImageUrl?: string | null;
  hasCoverImage?: boolean | null;
  originalCoverImageUrl?: string | null;
  published?: boolean | null;
  allowedVideoSharing?: boolean | null;
  serialized?: boolean | null;
  image?: File | null;
  coverImage?: File | null;
  uploadedSelfImage?: boolean | null;
  uploadedSelfCoverImage?: boolean | null;
  mainGenreId?: number | null;
  subGenreIds?: number[] | null;
  keywordNames?: string[] | null;
  imageBackgroundUri?: string | null;
  imageCharacterUri?: string | null;
  imageTextInfoList?: ImageTextInfo[] | null;
  coverImageBackgroundUri?: string | null;
  coverImageCharacterUri?: string | null;
  coverImageTextInfoList?: ImageTextInfo[] | null;
}

export default function action(payload: Params) {
  return (dispatch: Dispatch<any>) => {
    dispatch({
      payload,
      type: Types.UpdateStoryForm,
    });
    return new Promise(resolve => resolve(payload));
  };
}
